module.exports = __webpack_public_path__ + "img/top-0-4.7d35709d.jpg";